const content = {
    infoBlock: {
        infoblock1: {
            name: `Панель\r\nуправления`,
            text: `С помощью панели управления\r\nадминистратор может легко\r\nдобавлять новые сайты для\r\nпроверки безопасности, выбирать\r\nрежимы сканирования, управлять\r\nпользователями продукта,\r\nзнакомиться с результатами\r\nпроверок и многое другое.`
        },
        infoblock2: {
            name: `Генератор\r\nотчетов`,
            text: `С результами сканирования можно\r\nзнакомиться через панель\r\nуправления, зайдя в свой личный\r\nкабинет, а можно выгрузить в pdf-\r\nфайл для автономного изучения и\r\nвыполнения рекомендаций.`
        },
        infoblock3: {
            name: `Ролевая\r\nмодель`,
            text: `В панели управления существует\r\nглавная роль — администратор,\r\nкоторый может создавать других\r\nпользователей и управлять их\r\nдоступом к сканеру.`
        }
    },
    safety: {
        name: "Проверка\r\nзащищенности сайтов",
        text: `Система контроля защищенности сайтов "Веб\r\nБезопасность" содержит 56+ различных модулей,\r\nкоторые проверяют сайт на:\r\n\u0020\u2022 ошибки конфигурирования\r\n\u0020\u2022 возможности реализации угроз из OWASP Top 10\r\n\u0020\u2022 наличие стороннего вредоносного кода\r\n\u0020\u2022 признаки утечки конфиденциальной информации\r\n\u0020\u2022 наличие уязвимых сторонних библиотек и\r\n\u0020\u0020\u0020 компонентов\r\n\u0020\u2022 и т.д.`,
        imgUrl: "./images/safety-small.jpg"
    },
    control: {
        name: "Постоянный контроль",
        text: `Безопасность — это процесс. То, что сегодня\r\nявляется защищенным, завтра может уже содержать\r\nкритические уязвимости. Следуя этому принципу, в\r\nнашем сканере реализована возможность контроля\r\nбезопасности по заранее созданному расписанию.\r\nАдминистратор самостоятельно настраивает с какой\r\nпериодичностью и какими наборами проверяющих\r\nмодулей проводить сканирование.`,
        imgUrl: "./images/control-small.jpg"
    },
    api: {
        name: "API для интеграции",
        text: `Система "Веб Безопасность" содержит встроенное\r\nAPI для возможности программной интеграции в\r\nинфраструктуру заказчика и встраивания в pipeline-\r\nпроцесс. API содержит следующие основные\r\nвозможности:\r\n\u0020\u2022 получение списка доступных режимов\r\n\u0020\u0020\u0020 сканирования \r\n\u0020\u2022 постановка задачи на сканирование \r\n\u0020\u2022 получение статуса по запущенным\r\n\u0020\u0020\u0020 сканированиям \r\n\u0020\u2022 остановка выполнения запущенного\r\n\u0020\u0020\u0020 сканирования \r\n\u0020\u2022 получение отчета по выполненным задачам \r\n\u0020\u2022 получение списка зарегистрированных\r\n\u0020\u0020\u0020 пользователей \r\n\u0020\u2022 получение списка выполненных задач,\r\n\u0020\u0020\u0020 сгруппированных по пользователям`,
        imgUrl: "./images/API-small.jpg"
    },
    tariffs: {
        blockname: "Тарифы",
        web: {
            name: `Веб-сервис`,
            price: `Стоимость - от 15 000 ₽ в месяц`,
            text: `\r\n\u0020\u2022 4 еженедельных отчета\r\n\u0020\u2022 регулярный контроль\r\n\u0020\u0020\u0020 защищенности Вашего сайта\r\n\u0020\u2022 анализ динамики`,
            target: `\u0020\u0020\u0020Для малого и среднего бизнеса`
        },
        server: {
            name: `Серверная лицензия`,
            price: `Стоимость - от 1 000 000 ₽`,
            text: `\r\n\u0020\u2022 программный комплекс\r\n\u0020\u0020\u0020 устанавливается на Вашем\r\n\u0020\u0020\u0020 оборудовании \r\n\u0020\u2022 без ограничения количества сайтов \r\n\u0020\u2022 включает 1 год технической\r\n\u0020\u0020\u0020 поддержки от Правообладателя`,
            target: `\u0020\u0020\u0020Для крупного бизнеса и\r\n\u0020\u0020\u0020государственных структур`
        }
    }
};
export default content;
